<div class="d-flex flex-column gap-4">
  <div class="title-md" i18n>Required Contributions</div>
  <div class="d-flex flex-column gap-4" [formGroup]="formGroup">
    <!-- Row 1 -->
    <div class="d-flex">
      <div class="d-flex flex-column gap-1" style="width: 20.312rem">
        <label class="form-input-label" [for]="'contributionRateBasisTypeId'" i18n>Basis for Contribution Rates</label>
        <app-dropdown-input
          formControlName="contributionRateBasisTypeId"
          controlId="contributionRateBasisTypeId"
          [dropdowns]="basisForContributionRatesDropdownItems"
          [error]="formSubmitted && formGroup.controls.contributionRateBasisTypeId.invalid" />
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.contributionRateBasisTypeId.invalid"
          [customErrorMessages]="customErrorMessages.contributionRateBasisTypeId"
          [errors]="formGroup.controls.contributionRateBasisTypeId.errors" />
      </div>
    </div>
    <!-- Row 2 -->
    <div class="d-flex align-items-start">
      <!-- First column -->
      <div class="d-flex flex-column gap-1" style="width: 20.312rem">
        <label class="form-input-label" [for]="'matchedContributionRateTypeId'" i18n>
          Matched Contribution Rate Calculation
        </label>
        <app-dropdown-input
          formControlName="matchedContributionRateTypeId"
          controlId="matchedContributionRateTypeId"
          [dropdowns]="rateCalculationDropdownItems"
          [error]="formSubmitted && formGroup.controls.matchedContributionRateTypeId.invalid" />
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.matchedContributionRateTypeId.invalid"
          [customErrorMessages]="customErrorMessages.matchedContributionRateTypeId"
          [errors]="formGroup.controls.matchedContributionRateTypeId.errors" />
      </div>
      <!-- Second column -->
      <div class="d-flex" style="flex: 2" *ngIf="showMatchedPercentageInputs$ | async">
        <div class="d-flex" style="height: 100%">
          <img
            class="vert-form-divider"
            alt="divider"
            i18n-alt
            [src]="'assets/icons/employer-plan-config/vertical-form-divider.svg'" />
        </div>
        <ng-container *ngIf="showMatchedPercentageRange$ | async">
          <!-- Min Percentage -->
          <div class="d-flex flex-column gap-1" style="width: 9rem">
            <label class="form-input-label" [for]="'matchedContributionRateRangeFirstPercentage'">
              {{ matchedFirstPercentageLabel$ | async }}
            </label>
            <app-percentage-input
              formControlName="matchedContributionRateRangeFirstPercentage"
              controlId="matchedContributionRateRangeFirstPercentage"
              [error]="formSubmitted && formGroup.controls.matchedContributionRateRangeFirstPercentage.invalid" />
            <app-form-error
              *ngIf="formSubmitted && formGroup.controls.matchedContributionRateRangeFirstPercentage.invalid"
              [customErrorMessages]="customErrorMessages.matchedContributionRateRangeFirstPercentage"
              [errors]="formGroup.controls.matchedContributionRateRangeFirstPercentage.errors" />
          </div>
          <div class="d-flex" style="height: 100%">
            <img
              class="horizontal-form-divider"
              alt="divider"
              i18n-alt
              [src]="'assets/icons/employer-plan-config/horizontal-form-divider.svg'" />
          </div>
          <!-- Max Percentage -->
          <div class="d-flex flex-column gap-1" style="width: 9rem">
            <label class="form-input-label" [for]="'matchedContributionRateRangeSecondPercentage'">
              {{ matchedSecondPercentageLabel$ | async }}
            </label>
            <app-percentage-input
              formControlName="matchedContributionRateRangeSecondPercentage"
              controlId="matchedContributionRateRangeSecondPercentage"
              [error]="formSubmitted && formGroup.controls.matchedContributionRateRangeSecondPercentage.invalid" />
            <app-form-error
              *ngIf="formSubmitted && formGroup.controls.matchedContributionRateRangeSecondPercentage.invalid"
              [customErrorMessages]="customErrorMessages.matchedContributionRateRangeSecondPercentage"
              [errors]="formGroup.controls.matchedContributionRateRangeSecondPercentage.errors" />
          </div>
        </ng-container>
        <ng-container *ngIf="showMatchedPercentage$ | async">
          <!-- Percentage -->
          <div class="d-flex flex-column gap-1" style="width: 9rem">
            <label class="form-input-label" [for]="'matchedContributionRatePercentage'" i18n> Percentage </label>
            <app-percentage-input
              formControlName="matchedContributionRatePercentage"
              controlId="matchedContributionRatePercentage"
              [error]="formSubmitted && formGroup.controls.matchedContributionRatePercentage.invalid" />
            <app-form-error
              *ngIf="formSubmitted && formGroup.controls.matchedContributionRatePercentage.invalid"
              [customErrorMessages]="customErrorMessages.matchedContributionRatePercentage"
              [errors]="formGroup.controls.matchedContributionRatePercentage.errors" />
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Row 3 -->
    <div class="d-flex align-items-start">
      <!-- First column -->
      <div class="d-flex flex-column gap-1" style="width: 20.312rem">
        <label class="form-input-label" [for]="'unmatchedContributionRateTypeId'" i18n
          >Employer Unmatched Contribution Rate Calculation</label
        >
        <app-dropdown-input
          formControlName="unmatchedContributionRateTypeId"
          controlId="unmatchedContributionRateTypeId"
          [dropdowns]="rateCalculationDropdownItems"
          [error]="formSubmitted && formGroup.controls.unmatchedContributionRateTypeId.invalid" />
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.unmatchedContributionRateTypeId.invalid"
          [customErrorMessages]="customErrorMessages.unmatchedContributionRateTypeId"
          [errors]="formGroup.controls.unmatchedContributionRateTypeId.errors" />
      </div>
      <!-- Second column -->
      <div class="d-flex" style="flex: 2" *ngIf="showUnmatchedPercentageInputs$ | async">
        <div class="d-flex" style="height: 100%">
          <img
            class="vert-form-divider"
            alt="divider"
            i18n-alt
            [src]="'assets/icons/employer-plan-config/vertical-form-divider.svg'" />
        </div>
        <ng-container *ngIf="showUnmatchedPercentageRange$ | async">
          <!-- Min Percentage -->
          <div class="d-flex flex-column gap-1" style="width: 9rem">
            <label class="form-input-label" [for]="'unmatchedContributionRateRangeFirstPercentage'">
              {{ unmatchedFirstPercentageLabel$ | async }}
            </label>
            <app-percentage-input
              formControlName="unmatchedContributionRateRangeFirstPercentage"
              controlId="unmatchedContributionRateRangeFirstPercentage"
              [error]="formSubmitted && formGroup.controls.unmatchedContributionRateRangeFirstPercentage.invalid" />
            <app-form-error
              *ngIf="formSubmitted && formGroup.controls.unmatchedContributionRateRangeFirstPercentage.invalid"
              [customErrorMessages]="customErrorMessages.unmatchedContributionRateRangeFirstPercentage"
              [errors]="formGroup.controls.unmatchedContributionRateRangeFirstPercentage.errors" />
          </div>
          <div class="d-flex" style="height: 100%">
            <img
              class="horizontal-form-divider"
              alt="divider"
              i18n-alt
              [src]="'assets/icons/employer-plan-config/horizontal-form-divider.svg'" />
          </div>
          <!-- Max Percentage -->
          <div class="d-flex flex-column gap-1" style="width: 9rem">
            <label class="form-input-label" [for]="'unmatchedContributionRateRangeSecondPercentage'">
              {{ unmatchedSecondPercentageLabel$ | async }}
            </label>
            <app-percentage-input
              formControlName="unmatchedContributionRateRangeSecondPercentage"
              controlId="unmatchedContributionRateRangeSecondPercentage"
              [error]="formSubmitted && formGroup.controls.unmatchedContributionRateRangeSecondPercentage.invalid" />
            <app-form-error
              *ngIf="formSubmitted && formGroup.controls.unmatchedContributionRateRangeSecondPercentage.invalid"
              [customErrorMessages]="customErrorMessages.unmatchedContributionRateRangeSecondPercentage"
              [errors]="formGroup.controls.unmatchedContributionRateRangeSecondPercentage.errors" />
          </div>
        </ng-container>
        <ng-container *ngIf="showUnmatchedPercentage$ | async">
          <!-- Percentage -->
          <div class="d-flex flex-column gap-1" style="width: 9rem">
            <label class="form-input-label" [for]="'unmatchedContributionRatePercentage'" i18n> Percentage </label>
            <app-percentage-input
              formControlName="unmatchedContributionRatePercentage"
              controlId="unmatchedContributionRatePercentage"
              [error]="formSubmitted && formGroup.controls.unmatchedContributionRatePercentage.invalid" />
            <app-form-error
              *ngIf="formSubmitted && formGroup.controls.unmatchedContributionRatePercentage.invalid"
              [customErrorMessages]="customErrorMessages.unmatchedContributionRatePercentage"
              [errors]="formGroup.controls.unmatchedContributionRatePercentage.errors" />
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
